<style scoped>
  .description {
    font-size: 24px;
  }
</style>

<template>
  <section class="tableWrap">
    <h2 class="h2Title">통계 관리</h2>
    <div class="dashRow">
      <h2 class="tit arrowLink d-flex align-center justify-space-between">
        <span>Web 접속 현황</span>
      </h2>
      <div class="dashBx d-flex justify-space-around">
        <dl class="state">
          <dt>
            <em>{{counter.total.total | numeralFormat('0,000') }}</em> 건
          </dt>
          <dd>Total</dd>
        </dl>
        <dl class="state">
          <dt>
            <em>{{counter.today.total | numeralFormat('0,000')}}</em> 건
          </dt>
          <dd>Today</dd>
        </dl>
        <dl class="state">
          <dt>
            <em>{{counter.yesterday.total | numeralFormat('0,000')}}</em> 건
          </dt>
          <dd>Yesterday</dd>
        </dl>
      </div>
    </div>
    <div class="dashRow">
      <h2 class="tit arrowLink d-flex align-center justify-space-between">
        <span>Web Google Analytics</span>
        <div style="width:230px">
          <date-range-component v-on:event="getSearchDate" label="조회 기간" :value="searchDate"></date-range-component>
        </div>
      </h2>
      <div class="dashBx justify-space-around" >
        <v-col>
        <dl>
          <dt>
            <bar-chart :chart-data="dataset.dimensionPageView" :options="{maintainAspectRatio: false, onClick: handle}"/>
          </dt>
          <dd>페이지별 ViewCount</dd>
        </dl>
        </v-col>
      </div>
      <div class="dashBx d-flex justify-space-around">
        <dl class="state">
          <dt>
            <bar-chart :chart-data="dataset.pageview"/>
          </dt>
          <dd>{{startDate}} ~ {{endDate}} Page View</dd>
        </dl>
        <dl class="state">
          <dt>
            <line-chart :chart-data="dataset.visit" />
          </dt>
          <dd>{{startDate}} ~ {{endDate}} 방문자 수</dd>
        </dl>
        <dl class="state">
          <dt>
            <pie-chart :chart-data="dataset.browser" />
          </dt>
          <dd>{{startDate}} ~ {{endDate}} 브라우저별 접속 수</dd>
        </dl>
      </div>
    </div>
    <div class="dashRow">
      <h2 class="tit arrowLink d-flex align-center justify-space-between">
        <span>App Google Analytics</span>
      </h2>
      <div class="dashBx d-flex justify-space-around">
        <dl class="state">
          <b class="description">{{ dailyUsersTotalCount | number }}명</b>
          <dt>
            <line-chart
              :width="1592"
              :chart-data="dailyUsersChartData"
              :options="{ ...chartOptions, maintainAspectRatio: false }"
            />
          </dt>
          <dd>최근 한 달간 접속자</dd>
        </dl>
      </div>
      <div class="dashBx d-flex justify-space-around">
        <dl class="state">
          <b class="description">{{ realtimeUsersTotalCount | number }}명</b>
          <dt>
            <bar-chart
              :width="1592"
              :chart-data="realtimeUsersChartData"
              :options="chartOptions"
            />
          </dt>
          <dd>분당 사용자 수</dd>
        </dl>
      </div>
    </div>

  </section>

</template>

<script>

import statisticsApi from '@/api/StatisticsApi'
import boardApi from '@/api/BoardApi'
import pageApi from '@/api/PageApi'


import DateRageComponent from "@/views/component/DateRageComponent";

// import numeral from 'numeral'
import moment from 'moment'

import BarChart from './BarChart.js'
import LineChart from './LineChart.js'
import PieChart from './PieChart.js'

export default {
  name: 'Statistics',
  components: {BarChart, LineChart, PieChart,
    'date-range-component': DateRageComponent
  },
  data: () => ({
    dataset: {
      dimensionPageView: [],
      pageview: [],
      visit:[],
      browser:[]
    },
    counter: {
      today:{},
      total:{},
      yesterday:{}
    },
    searchDate: [],
    startDate:'',
    endDate:'',
    names: [],
    dailyUsers: [],
    dailyUsersTotalCount: 0,
    realtimeUsers: [],
    realtimeUsersTotalCount: 0,
  }),
  async mounted() {
    const boards = (await boardApi.list({size:-1})).content.map(b => {return {uri:`/board/${b.boardId}`, name: b.boardName}});
    const pages = (await pageApi.list({size:-1})).content.map(p => {return {uri:`/page/${p.pageId}`, name: p.title}});
    const etc = [
      {uri:'/my/myInfo', name: '내 정보'},
      {uri:'/my/board', name: '내 게시글'},
      {uri:'/my/inquiry', name: '1:1 문의'},
      {uri:'/my/message', name: '쪽지함'},
      {uri:'/my/meetList', name: '모임 내역'},
      {uri:'/my/videoInvite', name: '화상회의 초대'},
      {uri:'/my/videoInvite/', name: '화상회의 초대 상세'},
      {uri:'/my/videoConference', name: '전체 화상 회의'},
      {uri:'/my/myConference', name: '내가 개설한 화상 회의'},
      {uri:'/member/0', name:'회원현황'},
      {uri:'/member/1', name:'신규현황'},
      {uri:'/member/2', name:'연간일정'},
      {uri:'/meeting/6', name:'e-CLUB 소개'},
      {uri:'/meeting/7', name:'신규회원 안내'},
      {uri:'/group/schedule', name:'행사게시판'},
      {uri:'/community/0', name:'커뮤니티 메인'},
      {uri:'/find/findId', name:'아이디 찾기'},
      {uri:'/find/findPwd', name:'비밀번호 재설정 상세'},
      {uri:'/find/findPwdId', name:'비밀번호 재설정'},
    ]
    this.names = [...boards, ...pages, ...etc];

    this.fillData()
  },
  computed: {
    dailyUsersChartData() {
      if (!this.dailyUsers) return null;
      const labels = [...this.dailyUsers].map((u) => u.date);
      const data = [...this.dailyUsers].map((u) => u.data);
      const datasets = [{
        data,
        borderColor: '#9A5BD9',
        backgroundColor: 'rgba(154, 91, 217, .2)',
        label: '최근 한 달간 접속자',
      }];
      return {
        labels,
        datasets,
      };
    },
    realtimeUsersChartData() {
      if (!this.realtimeUsers) return null;
      const labels = [...this.realtimeUsers].map((u) => `${u.minuteAgo}분 전`);
      const data = [...this.realtimeUsers].map((u) => u.data);
      const datasets = [{
        data,
        backgroundColor: '#377BA6',
        label: `지난 30분 동안의 사용자 (${this.realtimeUsersTotalCount}명)`,
      }];
      return {
        labels,
        datasets,
      };
    },
    chartOptions() {
      return {
        scales: {
            yAxes: [{
              ticks: {
                  stepSize: 1
              }
            }]
        },
      };
    },
  },
  filters: {
    number: (n) => {
      if (typeof n !== 'number') return n;
      return n.toLocaleString();
    }
  },
  methods: {
    handle(p, e) {
      const item = e[0];
      const uri = this.dataset.dimensionPageView.labels[item._index];
      if(confirm('선택하신 페이지로 이동하시겠습니까?'))
        window.open(process.env.VUE_APP_HOME + uri, '_home');
      // this.$emit('on-receive', {
      //   index: item._index,
      //   backgroundColor: item._view.backgroundColor,
      //   value: this.values[item._index]
      // })
    },
    getSearchDate(searchDate = []) {
      this.searchDate = searchDate;
      if(this.searchDate && this.searchDate.length === 2)
        this.fillData();
    },
    getDailyUsers() {
      statisticsApi.getRecentlyUsers('daily', 28).then((response) => {
        this.dailyUsers = response ? response.data?.report : [];
        this.dailyUsersTotalCount = response ? response.data?.total : 0;
      });
    },
    getRealtimeUsers() {
      statisticsApi.getRecentlyUsers('realTime', 29).then((response) => {
        this.realtimeUsers = response ? response.data?.report : [];
        this.realtimeUsersTotalCount = response ? response.data?.total : 0;
      });
    },
    fillData () {
      this.startDate = this.$moment().add('day', -7).format('YYYY-MM-DD');
      this.endDate = this.$moment().format('YYYY-MM-DD');
      if (this.searchDate && this.searchDate.length > 0) {
        this.startDate = this.searchDate[0];
        this.endDate = this.searchDate[1];
      }
      this.searchDate = [this.startDate, this.endDate]

      // {type:2, start:'7DaysAgo'}
      statisticsApi.get({type:2, start:this.startDate, end:this.endDate}).then(result => {
        // console.log(result.data);

        // result.data.forEach(v => {
        //   console.log(Object.keys(v)?.[0]??'');
        //   console.log(v[Object.keys(v)?.[0]??'']);
        // });
        const labels = result.data.map(v => moment(Object.keys(v)[0]).format('YYYY.MM.DD'));
        const datas = result.data.map(v => v[Object.keys(v)?.[0]??'']);

        this.dataset.pageview = {
          labels: [...labels],
          datasets: [
            {
              label: `${this.startDate} ~ ${this.endDate} Page View`,
              backgroundColor: '#f87979',
              data: [...datas]
            }
          ]
        }
      });
      statisticsApi.get({type:1, start:this.startDate, end:this.endDate}).then(result => {
        const labels = result.data.map(v => moment(Object.keys(v)[0]).format('YYYY.MM.DD'));
        const datas = result.data.map(v => v[Object.keys(v)?.[0]??'']);

        this.dataset.visit = {
          labels: [...labels],
          datasets: [
            {
              label: `${this.startDate} ~ ${this.endDate} 방문자수`,
              backgroundColor: '#669FF0',
              data: [...datas]
            }
          ]
        }
      });
      statisticsApi.get({type:3, start:this.startDate, end:this.endDate}).then(result => {

        const labels = result.data.map(v => Object.keys(v)[0]);
        const datas = result.data.map(v => v[Object.keys(v)?.[0]??'']);

        this.dataset.browser = {
          labels: [...labels],

          datasets: [
            {
              label: `${this.startDate} ~ ${this.endDate} 브라우저 별 접속 수`,
              backgroundColor: ['#ffce56', '#36a2eb', '#CD853F', '#ff6384', '#cc65fe'],
              data: [...datas],

            }
          ]
        }
      });
      statisticsApi.getCredentials().then(credit => {
        statisticsApi.getFromGA(credit.token, credit.view, this.startDate, this.endDate, 50).then(result => {
          // https://www.googleapis.com/analytics/v3/data/ga?ids=ga%3A235046896&start-date=30daysAgo&end-date=yesterday&metrics=ga%3Asessions%2Cga%3Apageviews&dimensions=ga%3ApagePath%2Cga%3Adate
          const labels = result.rows
              .filter(v => !['/main', '/login'].includes(v[0]))
              .map(v => {
                const uri = v[0]
                return (
                    this.names
                        .filter(
                            n => n.uri === uri ||
                            n.uri === uri.replace('write/', '') ||
                                (uri.indexOf('/my/videoInvite/') === 0 && n.uri === '/my/videoInvite/')
                        )
                        .map(n =>
                            {
                              // board uri 이름 mapping
                              if(uri.indexOf('/board/write/') === 0) {
                                n.name = n.name + ' 쓰기';
                              }
                              return n;
                            }
                        )?.[0]?? { name: uri}
                ).name
              });
          const datas = result.rows.filter(v => !['/main', '/login'].includes(v[0])).map(v => v[2]);

          this.dataset.dimensionPageView = {
            labels: [...labels],

            datasets: [
              {
                label: `${this.startDate} ~ ${this.endDate} 페이지 별 접속 수`,
                backgroundColor: [
                  "rgba(255, 99, 132, 0.2)",
                  "rgba(54, 162, 235, 0.2)",
                  "rgba(255, 206, 86, 0.2)",
                  "rgba(75, 192, 192, 0.2)",
                  "rgba(153, 102, 255, 0.2)",
                  "rgba(255, 159, 64, 0.2)",
                ],
                borderColor: [
                  "rgba(255,99,132,1)",
                  "rgba(54, 162, 235, 1)",
                  "rgba(255, 206, 86, 1)",
                  "rgba(75, 192, 192, 1)",
                  "rgba(153, 102, 255, 1)",
                  "rgba(255, 159, 64, 1)",
                ],
                borderWidth: 1,
                data: [...datas],
              }
            ]
          }
        })
      })
      this.getDailyUsers();
      this.getRealtimeUsers();
    },
  },
  created: function () {
    statisticsApi.simple().then(result => {
      this.counter = result;
    })
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/layout/variables';
.dashWrap{
  display: flex;
}
.dashRow{
  display: flex;
  flex-direction: column;
  flex: 0 0 49%;
  &:first-child{
    margin-right: 2%;
  }
}
.tit{
  margin-top: 30px;
  margin-left: 5px;
  margin-bottom: 10px;
  font-size: 18px;
}
.dashBx{
  padding: 20px;
  border: 1px solid #e9e9e9;
  .state{
    padding-top: 37px;
    padding-bottom: 37px;
    cursor: pointer;
    color: #666;
    dt{
      display: flex;
      justify-content: center;
      align-items: baseline;
      margin-bottom: 20px;
      em{
        margin-right: 5px;
        font-size: 50px;
        font-weight: bold;
        color: #333;
      }
    }
    dd{
      font-weight: 500;
    }
  }
  .deposit{
    display: flex;
    padding: 0;
    li{
      display: flex;
      justify-content: space-between;
      flex: 0 0 25%;
      &:nth-child(3){
        flex: 0 0 24%;
      }
      .depositTit{
        width: 100px;
        height: 30px;
        line-height: 30px;
        border: 1px solid #ccc;
        border-radius: 25px;
        background: #f6f6f6;
        font-size: 13px;
        font-weight: 600;
        color: #555;
        text-align: center;
      }
      .depositNum{
        display: flex;
        padding-top: 50px;
        padding-right: 30px;
        p{
          margin-right: 50px;
          em{
            font-size: 40px;
            font-weight: bold;
          }
        }
      }
    }
  }
}

.h3Title {
  @include h3-title;
}

.col {
  padding: 0;
}

.fieldWrap {
  @include form-bx;

  .fieldBx {
    position: relative;
    width: 1600px;

    .searchBtn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 0;
    }

    .formList {
      display: flex;
      flex-direction: row;
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }

      dl {
        display: flex;
        align-items: center;
        flex-direction: row;
        margin-right: 20px;

        .formTit {
          @include form-font;
          flex: 0 0 80px;
        }

        dd {
          display: flex;
          align-items: center;
        }
      }
    }
  }
}

.tableBx {
  flex: 1 auto;
  max-width: 500px;
  margin: 50px auto;

  ul {
    display: flex;
    flex-direction: row;
    align-items: center;

    .tableBtnList {
      margin-right: 15px;
    }
  }
}

.ti-new-tag-input {
  font-size: 12px;
}

</style>
